// pl-PL
export default {
	title: "Centrum kart upominkowych",
	myPoints: "Moje punkty",
	SelectedGifts: "Wybrane prezenty",
	form: {
		label: {
			title: "Wyszukiwanie",
			points: "Punkty"
		}
	},
	redemption: "Odkupienie",
	stock: "Magazyn",
	id: {
		redeemPoints: "Wymień wymagane punkty:",
		btn: "Wymień teraz",
		title: "Informacja o zakupie",
		content: `Drogi pracowniku, dziękujemy za udział w pracy.\n\nPrzed wymianą punktów prosimy o zapoznanie się z poniższymi warunkami:\n\n[Punkty pracy] Po codziennym zakończeniu optymalizacji danych zestawu zamówień pracownicy mogą zdobyć 1 punkt upominkowy, który może można wykorzystać do częściowej realizacji sponsorowanego prezentu.\n[Wykorzystanie prezentu] Pracownicy muszą podać odpowiednie dane adresowe do wysyłki, a prezent zostanie wysłany bezpłatnie na cały świat w ciągu 14 dni. Po zakończeniu realizacji możesz skontaktować się z obsługą klienta, aby uzyskać numer śledzenia umożliwiający śledzenie postępu prezentu. Platforma nie udostępnia informacji osobom trzecim.\nUwaga: punkty wymienione na prezenty nie podlegają zwrotowi`
	},
	applyDialog: {
		title: "Otrzymywanie informacji",
		form: {
			consignee: "Odbiorca",
			area: "Obszar",
			telephone: "Telefon",
			deliveryAddress: "Adres dostawy"
		},
		btn: "Prześlij"
	},
	records: {
		title: "Rekordy",
		status: ["Oczekujące na wysyłkę", "Wysłane", "Dostarczone", "Anulowane"]
	}
};
